import { InjectionToken } from '@angular/core';
import { AbstractStepDTO } from '@tj/tj-dmp-lib-api';

export const STEP_TOKEN = new InjectionToken<AbstractStepDTO>('STEP_TOKEN');
export const TENANT_TOKEN = new InjectionToken<string>('TENANT_TOKEN');
export const PARTNER_TOKEN = new InjectionToken<string>('PARTNER_TOKEN');
export const READ_ONLY_MODE_TOKEN = new InjectionToken<boolean>('READ_ONLY_MODE_TOKEN');
export const ON_SAVE_TOKEN = new InjectionToken<() => void>('ON_SAVE_TOKEN');
export const ON_CANCEL_TOKEN = new InjectionToken<() => void>('ON_CANCEL_TOKEN');
/** Première étape (point d'entrée) du scénario édité : permet à une étape d'adapter ses choix à la façon dont le scénario démarre. */
export const ENTRY_STEP_TOKEN = new InjectionToken<AbstractStepDTO | null>('ENTRY_STEP_TOKEN');
